import classes from "./SiderContentC.module.css";
import { Menu, message } from "antd";

import signInSignUpLogo from "../../../assets/signInSignUp.png";
import { MdDashboard } from "react-icons/md";

import { Link } from "react-router-dom";
import axios from "axios";

import { useNavigate } from "react-router-dom";
import { MdAssignmentTurnedIn } from "react-icons/md";
import {
  FaSignOutAlt,
} from "react-icons/fa";


const { SubMenu } = Menu;

const SiderContentS = (props) => {
  const history = useNavigate();

  const handleLogout = (event) => {
    axios
      .get(props.url + "/api/v1/users/logout", {
        withCredentials: true,
      })
      .then((response) => {
        message.success({
          content: "Goodbye!!!! See You Again!!!",
          className: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        history("/");
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  return (
    <>
      <img
        className={classes["SignInSignUpLogo"]}
        src={signInSignUpLogo}
        alt="Logo"
      />
      <Menu
        mode="inline"
        defaultSelectedKeys={["empDashboard"]}
        // defaultOpenKeys={["misc"]}
        style={{
          height: "100%",
          borderRight: 0,
          overflowY: "auto",
        }}
        theme="light"
      >
        <Menu.Item key="empDashboard" icon={<MdDashboard />}>
          <Link to="/jobwork/dashboard" style={{ textDecoration: "none" }}>
            Dashboard
          </Link>
        </Menu.Item>

        {/* <SubMenu key="transection" title="Jobwork" icon={<FaFileInvoice />}>
          <Menu.Item key="indent-register">
            <Link
              to="/jobwork/transection/job-work"
              style={{ textDecoration: "none" }}
            >
              Job Work
            </Link>
          </Menu.Item>
        </SubMenu> */}

        <SubMenu key="transactions" title="Transactions" icon = {<MdAssignmentTurnedIn />}>
                    <Menu.Item key="daily-attendance" >
                        <Link to = '/jobwork/transection/job-work'  style={{ textDecoration: "none" }}>
                        JobWork Outward
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="leave" >
                        <Link to = '/jobwork/transection/job-work-inward'  style={{ textDecoration: "none" }}>
                        JobWork Inward
                        </Link>
                    </Menu.Item>
                 
                </SubMenu>

      

        <Menu.Item
          key="empLogout"
          onClick={(event) => handleLogout(event)}
          icon={<FaSignOutAlt style={{ color: "red", opacity: "0.7" }} />}
        >
          <Link to="/" style={{ textDecoration: "none" }}>
            Logout
          </Link>
        </Menu.Item>
      </Menu>
    </>
  );
};

export default SiderContentS;
